import {SOPutPeriod} from '../../core/period/so-put-period';
import {PeriodCore} from './period.core';
import {SOGetPeriod} from '../../core/period/so-get-period';
import {FormField, SelectionOption} from 'lionheartland';
import {putPeriodFormFieldOptions} from './put-period-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutPeriod extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putPeriodFormFieldOptions);

  RequestClass = SOPutPeriod

  constructor(
    public entityCore: PeriodCore
  ) {
    super();
    if (putPeriodFormFieldOptions.project) {
      putPeriodFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('numeral'),
      this.getFormValueFromIdentifier('type'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}